<template>
    <v-container>
        <v-card>
            <v-row class="ma-4" wrap>
                <v-card-title>Organisation Users</v-card-title>
                <v-card-actions>
                    <v-btn @click="openAddUserDialog()">Add User to Organisation</v-btn>
                </v-card-actions>
                <v-spacer></v-spacer>
                    <!-- Icon + User quota -->
                    <span>
                        {{this.getUserCount}}/{{this.getMaxUserCount}}
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-icon color="primary" class="ma-2" v-on="on">mdi-account-group</v-icon>
                            </template>
                            <span>Max Users</span>
                        </v-tooltip>
                    </span> 
            </v-row>
            <v-row>
                <v-container class="ma-4 pa-2">
                    <v-data-table
                    :headers="[
                    {text: 'ID', value: 'id'}, 
                    {text: 'Name', value: 'data.displayname'}, 
                    {text: 'Email', value: 'data.email'}, 
                    {text: 'Admin', value: 'admin'},
                    {text: 'Actions', value: 'actions', sortable: false}]"
                    :items="localUsers"
                    sort-by="name"
                    class="elevation-1"
                    dense
                    :loading="loading" 
                    loading-text="Loading Users... Please wait"
                    >
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon
                            small
                            class="mr-2"
                            @click="viewProfile(item)"
                            >
                            mdi-information
                            </v-icon>
                            <v-icon
                            small
                            @click="openRemoveUserDialog(item)"
                            >
                            mdi-account-remove
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-container>
            </v-row>
        </v-card>

        <v-dialog v-model="viewProfileDialog" :retain-focus="false" fullscreen hide-overlay transition="dialog-bottom-transition">              
            <profile-screen
            v-if="viewProfileDialog"
            v-on:dialogClosed="closeViewProfile()"
            :user="currentViewedUser"
            :label="currentViewedUser.displayname"
            :myProfile="false">
            </profile-screen>
        </v-dialog>

        <v-dialog v-model="addUserDialog" :retain-focus="false" fullscreen hide-overlay transition="dialog-bottom-transition">              
            <add-user-popup
            v-if="addUserDialog"
            :loading="addLoading"
            v-on:addNewUser="addUser($event, false)"
            v-on:addExistingUser="addUser($event, true)"
            v-on:dialogClosed="closeAddUserDialog()">
            </add-user-popup>
        </v-dialog>

        <!-- REMOVE USER BASIC DIALOG  -->
        <v-dialog
        v-model="removeUserDialog"
        persistent
        max-width="290"
        >
            <v-card>
            <v-card-title class="headline">
                Remove User From Organisation?
            </v-card-title>
            <v-card-text>Are you sure you wish to remove this user (Email: {{ getRemoveUserEmail }}) from the organisation?</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                color="primary"
                text
                @click="closeRemoveUserDialog()"
                >
                No
                </v-btn>
                <v-btn
                text
                @click="removeUser(removeUserInfo)"
                >
                Yes
                </v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>


    </v-container>
</template>

<script>
import UserDataService from './../../../services/userDataService.js';
import ProfileScreen from './../ProfileScreen.vue';
import AddUserPopup from './AddUserPopup.vue';
import Toast from './../../../plugins/customToast.js';

export default {
    name: 'userManagement',
    components: {
        ProfileScreen,
        AddUserPopup
    },
    props: {
      users: Array,
      organisation: Object,
      usersLoading: Boolean
    },
    mounted(){
        //Set our local userDataService to be the same as the parent organisation screen service prop
        this.userDataService = new UserDataService();
        if (this.organisation){
            this.localOrg = this.organisation;
        }
    },
    methods: {    
        openAddUserDialog(){
            this.addUserDialog = true;
            this.addUserInfo = {};
        },
        closeAddUserDialog(){
            this.addUserDialog = false;
            this.addUserInfo = {};
        },
        openRemoveUserDialog(item){
            this.removeUserDialog = true;
            this.removeUserInfo = item;
        },
        closeRemoveUserDialog(){
            this.removeUserDialog = false;
            this.removeUserInfo = {};
        },
        async addUser(userData, existing){
            if (this.userDataService) {
                this.addLoading = true;
                //First check if it is a new user or existing one
                if (existing){
                    //If its existing it will just contain the id
                    await this.userDataService.addUserToOrganisation(this.localOrg, true, userData)
                    .then((result) => {
                        if (result === "Success"){
                            Toast.fire({  icon: 'success',  title: `Successfully added user to organisation`});
                            //If successful we can close the dialog
                            this.closeAddUserDialog();
                        } else {
                            Toast.fire({  icon: 'error',  title: `Error: ${result}`});
                        }
                        this.addLoading = false;
                    })
                    .catch((error) => {
                        Toast.fire({  icon: 'error',  title: `Error: ${error}`});
                        this.addLoading = false;
                    });                    
                } else {
                    //If they are new ensure to put in the newData
                    await this.userDataService.addUserToOrganisation(this.localOrg, false, userData)
                    .then((result) => {
                        if (result === "Success"){
                            Toast.fire({  icon: 'success',  title: `Successfully created new user`});
                            //If successful we can close the dialog
                            this.closeAddUserDialog();
                        } else {
                            Toast.fire({  icon: 'error',  title: `Error: ${result}`});
                        }
                        this.addLoading = false;
                    })
                    .catch((error) => {
                        Toast.fire({  icon: 'error',  title: `Error: ${error}`});
                        this.addLoading = false;
                    });            
                }
            }
        },
        async removeUser(item) {
            this.closeRemoveUserDialog();
            if (this.userDataService) {
                this.removeLoading = true;
                //First check the user actually exists
                if (item && item.data) {
                    const userToRemove = item.data;
                    await this.userDataService.removeUserFromOrganisation(this.localOrg, userToRemove)
                    .then((result) => {
                        if (result === "Success"){
                            Toast.fire({  icon: 'success',  title: `Successfully removed a user from the organisation`});
                        } else {
                            Toast.fire({ icon: 'error', title: `Error: ${result}`})
                        }
                        this.removeLoading = false;
                    })
                    .catch((error) => {
                        Toast.fire({ icon: 'error', title: `Error: ${error}`})
                        this.removeLoading = false;
                    })
                } else {
                    Toast.fire({  icon: 'error',  title: `Error: User couldn't be removed (couldn't be found)`});
                    this.removeLoading = false;
                }

                

            }
        },
        handleClick(value){
            this.viewProfile(value);
        },
        viewProfile(item){
            this.currentViewedUser = item.data;
            this.viewProfileDialog = true;
        },
        closeViewProfile(){
            this.currentViewedUser = {}
            this.viewProfileDialog = false;
        }
    },
    computed: {
        getUserCount(){
            if (this.localOrg && this.localOrg.users){
                return this.localOrg.users.length;
            }
            return "0";
        },
        getMaxUserCount(){
            if (this.localOrg && this.localOrg.maxUsers){
                return this.localOrg.maxUsers;
            }
            return "N/A";
        },
        getRemoveUserEmail(){
            if (this.removeUserInfo && this.removeUserInfo.data) {
                return this.removeUserInfo.data.email;
            }
            return null;
        }
    },
    watch: {
        usersLoading: { 
            // the callback will be called immediately after the start of the observation
            immediate: true, 
            handler (val) {
                this.loading = val;
            },
        },
        users: {
            // the callback will be called immediately after the start of the observation
            immediate: true, 
            handler (val) {
                this.localUsers = val;
            },
        },
        organisation: {
            immediate: true,
            handler(val) {
                this.localOrg = val;
            }
        }
    },
    data: () => ({
        userDataService: {},
        loading: true,
        localUsers: {},
        localOrg: {},
        viewProfileDialog: false,
        currentViewedUser: {},
        addUserInfo: {},
        addUserDialog: false,
        addLoading: false,
        removeUserInfo: {},
        removeUserDialog: false,
        removeLoading: false
    })    
}
</script>